import { Divider, Grid2, Show } from "components";
import { FeePlanById } from "interfaces/Revenue";
import ManagementFeeForm from "./ManagementFeeForm";
import PerformanceFeeForm from "./PerformanceFeeForm";
import SubscriptionFeeForm from "./SubscriptionFeeForm";

interface Props {
  data: FeePlanById;
}

const RevenueProducts = (props: Props) => {
  const { data } = props;

  const isManagementFee = data?.revenueProducts?.includes("management_fee");
  const isPerformanceFee = data?.revenueProducts?.includes("performance_fee");
  const isSubscriptionFee = data?.revenueProducts?.includes("subscription_fee");

  return (
    <Grid2 container spacing={4}>
      <Show.When isTrue={!!isManagementFee}>
        <Grid2 size={12}>
          <ManagementFeeForm />
        </Grid2>
      </Show.When>

      <Show.When isTrue={!!isPerformanceFee}>
        <Grid2 size={12}>
          <Divider />
        </Grid2>
        <Grid2 size={12}>
          <PerformanceFeeForm />
        </Grid2>
      </Show.When>

      <Show.When isTrue={!!isSubscriptionFee}>
        <Grid2 size={12}>
          <SubscriptionFeeForm />
        </Grid2>
      </Show.When>
    </Grid2>
  );
};

export default RevenueProducts;
